import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import {
  fetchPenaltyFeesByLoanIdAction,
  selectPenaltyFees,
  stornoPenaltyFeeRequest
} from '../ducks';
import PenaltyFeeList from './PenaltyFeeList';
import { currencyFormatter, formatDateTime } from '../../../common/utils/helpers';

const mapStateToProps = state => ({
  // items: selectPenaltyFees(state),
});

const mapDispatchToProps = dispatch => ({

  actions: bindActionCreators(
    {
      fetchPenaltyFeesByLoanId: fetchPenaltyFeesByLoanIdAction.request,
      stornoPenaltyFee: stornoPenaltyFeeRequest,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class PenaltyFeeCollapseList extends Component {

  static propTypes = {
    loanId: PropTypes.string.isRequired,
    items: PropTypes.array,
    isLoading: PropTypes.bool
  };

  componentDidMount() {
    const {
        actions,
        loanId
    } = this.props;

    // actions.fetchPenaltyFeesByLoanId(loanId);
  }

  render() {
    const {
      items,
      isLoading,
      actions,
    } = this.props;

    return (
      <React.Fragment>

        <div>
          <PenaltyFeeList
            items={items}
            isLoading={isLoading}
            onDelete={item => {
              actions.stornoPenaltyFee({ id: item.id, loanId: item.loanId});
            }}
          />
        </div>
      </React.Fragment>

    );
  }
}




// WEBPACK FOOTER //
// ./src/features/penalty-fee/components/PenaltyFeeCollapseList.js